import axiosInstance from "../Instance/axiosInstance";

// existing
export const getAllInvoices = async () => {
  return axiosInstance.get("/admin/get-all-invoices");
};

export const updateInvoiceAndPayment = async (orderId, data) => {
  return axiosInstance.put(
    `/admin/update-invoice-payment/${orderId}`,
    data,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }
  );
};